import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Field from '../field';
import ButtonRecipe from '../buttonRecipe';
import { Form, Footer } from './styles';

const EstablishmentCreatedModal = ({ onClose }) => {
  return (
    <Formik
      initialValues={{
        establishmentName: '',
        phone: '',
        email: '',
        cnes: '',
        cnpj: '',
        adress: '',
      }}
      validationSchema={Yup.object({
        establishmentName: Yup.string().required('Campo obrigatório'),
        phone: Yup.string().required('Campo obrigatório'),
        email: Yup.string().required('Campo obrigatório'),
        cnes: Yup.string().required('Campo obrigatório'),
        cnpj: Yup.string().required('Campo obrigatório'),
        adress: Yup.string().required('Campo obrigatório'),
      })}
      onSubmit={(values) => {
        return values;
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <div>
            <Field
              error={props.touched.cnpj && props.errors.cnpj}
              id="cnpj"
              name="cnpj"
              placeholder="CNPJ"
              label="cnpj"
              value={props.values.cnpj}
              onChange={props.handleChange}
            />

            <Field
              error={props.touched.cnes && props.errors.cnes}
              id="cnes"
              name="cnes"
              placeholder="CNES"
              label="cnes"
              value={props.values.cnes}
              onChange={props.handleChange}
            />
          </div>

          <div>
            <Field
              error={
                props.touched.establishmentName &&
                props.errors.establishmentName
              }
              id="establishmentName"
              name="establishmentName"
              placeholder="Estabelecimento"
              label="nome"
              value={props.values.establishmentName}
              onChange={props.handleChange}
            />

            <Field
              error={props.touched.email && props.errors.email}
              id="email"
              name="email"
              placeholder="Digite seu e-mail"
              label="e-mail"
              value={props.values.email}
              onChange={props.handleChange}
            />
          </div>

          <div>
            <Field
              error={props.touched.phone && props.errors.phone}
              id="phone"
              name="phone"
              placeholder="Digite o telefone"
              label="telefone"
              value={props.values.phone}
              onChange={props.handleChange}
            />

            <Field
              error={props.touched.adress && props.errors.adress}
              id="adress"
              name="adress"
              placeholder="Endereço do estabelecimento"
              label="endereço"
              value={props.values.adress}
              onChange={props.handleChange}
            />
          </div>

          <Footer>
            <ButtonRecipe
              type="button"
              width="111px"
              textColor="#2196f3"
              backgroundColor="#F9F9FB"
              borderColor="#2493EB"
              onClick={onClose}
            >
              Cancelar
            </ButtonRecipe>
            <ButtonRecipe
              type="submit"
              width="152px"
              textColor="#fff"
              backgroundColor="#2493EB"
              borderColor="#2493EB"
              marginLeft="20px"
              marginRight="none"
            >
              Criar
            </ButtonRecipe>
          </Footer>
        </Form>
      )}
    </Formik>
  );
};

EstablishmentCreatedModal.propTypes = {
  onClose: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.func.isRequired,
  errors: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};
EstablishmentCreatedModal.defaultProps = {
  onClose: () => {},
};

export default EstablishmentCreatedModal;
